import React from 'react'

import {
createMuiTheme,
        MuiThemeProvider,
        withStyles
} from "@material-ui/core/styles"
import Tooltip from "@material-ui/core/Tooltip"


        const defaultTheme = createMuiTheme();
const theme = createMuiTheme({
    overrides: {
        MuiTooltip: {
            tooltip: {
                fontSize: "1.2em",
                color: "white",
                backgroundColor: "gray",
                border: "1px solid gray",
                fontFamily: "iranyekan !important"
            }
        }
    }
});
const tooltip = (props) => {
    return (
            <MuiThemeProvider theme={defaultTheme}>
                <MuiThemeProvider theme={theme}>
                    <Tooltip title={props.text}>
                        <div style={{marginBottom: "20px", width: "100%", height: "100%", fontFamily: "iranyekan !important"}} className={props.class}>
                            {props.head}
                        </div>
                    </Tooltip>
                </MuiThemeProvider>
            </MuiThemeProvider>
            )
}

export default tooltip